import { Base } from "./Base";

export class SignUp extends Base {
    constructor(public contestantState) {
        super(contestantState);
        this.STATE_LEVEL = 2;
    }

    public getActiveTitle() {
        switch (this.contestantState) {
            case this.CONTESTANT_STATE_NOT_SIGNED_UP: {
                return "signup";
            }
            case this.CONTESTANT_STATE_SIGN_UP_PENDING: {
                return "signup";
            }
            case this.CONTESTANT_STATE_SIGNED_UP: {
                return "checkin";
            }
            case this.CONTESTANT_STATE_CHECKED_IN: {
                return "play";
            }
        }
    }

    public showSignedUpTitle() {
        return this.contestantState !== this.CONTESTANT_STATE_NOT_SIGNED_UP;
    }

    public isSignUpEnabled() {
        return this.contestantState == this.CONTESTANT_STATE_NOT_SIGNED_UP;
    }

    public getNotSignedUpTemplates() {
        return ["UserAction"];
    }

    public getSignedUpTemplates() {
        return ["UserAction"];
    }

    public getCheckedInTemplates() {
        return [];
    }

    public getPlayingTemplates() {
        return ["Match", "Result"];
    }

    public getFinishedTemplates() {
        return ["Information", "Result"];
    }
}
